import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseCircleFilled,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Dropdown, Layout, Menu } from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom'
import {
  ApplicationType,
  removeCredentials,
  selectApplicationType,
  selectEndTime,
  selectShortName,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../app/applicationSlice'
import { RootDispatch } from '../app/store'
import { NotFound } from '../compnents/dummy/NotFound'
import Icon, {
  LogoFilled,
  LogoutOutlined,
  RefreshFilled,
  UpgradeOutlined,
  UserHomeOutlined,
} from '../compnents/icons/Icons'

import { Departments } from '../features/department/Departments'
import { GrantPage } from '../features/grant/GrantPage'
import { Menus } from '../features/menu/Menus'
import { PrintAssignment } from '../features/print/PrintAssignment'
import { getPrintTemplateList } from '../features/print/printSlice'
import { setSettings } from '../features/settings/settingsSlice'
import { ServiceDelay } from '../features/tenant/serviceDelay'
import { TenentSetting } from '../features/tenant/setting/tenentSetting'
import { Tenants } from '../features/tenant/Tenants'
import {
  getSettingDetail,
  selectSettings,
} from '../features/user/setting/settingSlice'
import { Users } from '../features/user/Users'
import { Menu as MenuModel } from '../models/menu'
import { PayMethod } from '../models/payment'
import { PrintTemplateCategory } from '../models/print'
import { Checks, Settings } from '../models/setting'
import { ThemeContext } from '../theme/ThemeContext'
import { isChrome } from '../utils/SystemUtils'
import styles from './Layout.module.css'
import {
  getMenus,
  removeBreadcrumbs,
  selectAppShadeIsModal,
  selectAppShadeTipText,
  selectBreadcrumbs,
  selectCurrentRoute,
  selectFixedMenus,
  selectMenus,
  setAppShadeIsModal,
  setAppShadeTipText,
  traceHint,
  traceRoute,
  untraceRoute,
} from './layoutSlice'
import { resetDiagnosis } from '../features/treatment/diagnosis/diagnosisSlice'
import { UserPersonalSetting } from '../features/personalManagement/personalSetting/UserPersonalSetting'
import { ReplaceMakeSupplier } from '../features/replaceMakeCenter/ReplaceMakeSupplier'
import { ReplaceMakeOrganization } from '../features/replaceMakeOrganization/ReplaceMakeOrganization'
import { StatisticAnalysisNavBar } from '../features/statisticAnalysis/StatisticAnalysis'
import { PartnerPlatform } from '../features/partnerPlatform/PartnerPlatform'
import { SupplierPartner } from '../features/replaceMakeCenter/compnents/SupplierPartner'
import { ReplaceMakeOrderDetail } from '../features/statisticAnalysis/components/order/OrderDetail'
import { OrganizationPartner } from '../features/replaceMakeOrganization/compnents/OrganizationPartner'
import { Medical } from '../features/medical/Medical'
import { Insurance } from '../features/insurance/Insurance'
import { ReplaceCenter } from '../features/replaceMakeCenter/ReplaceCenter'
import { NotificationStatin } from '../features/message/notification'
import { DataImportPage } from '../features/dataImport/dataImportPage'
import { TenantNavBar } from '../features/tenant/TenantTabber'
import { OrderRecordPage } from '../features/orderRecord/orderRecordPage'
import { PriceSetPage } from '../features/priceSet/priceSetPage'
import { MonitoringTab } from '../features/monitoring/monitoringTab'
import { Advertising } from '../features/advertising/Advertising'
import { LabelManagementPage } from '../features/labelManagement/labelManagementPage'
import { RegulatoryDataTab } from '../features/regulatoryData/regulatoryDataTab'
import { HerbsDirectoryPage } from '../features/replaceMakeCenter/compnents/HerbsDirectoryPage'
import { ReservationChannelList } from '../features/reservationChannel/reservationChannel'
import { VersionManagement } from '../features/versionManagement/versionManagement'
import { AiTuningPage } from '../features/AiTuning/AiTuning'
const { Header, Content, Sider } = Layout

const { SubMenu } = Menu

export const DefaultLayout = (): ReactElement => {
  const applicationType = useSelector(selectApplicationType)

  const theme = useContext(ThemeContext)

  const location = useLocation()

  const ref = useRef<HTMLDivElement>(null)

  const history = useHistory()

  const tenantName = useSelector(selectTenantName)

  const shortName = useSelector(selectShortName)

  const userName = useSelector(selectUserName)

  const appEndTime = useSelector(selectEndTime)

  const settings = useSelector(selectSettings)

  const menus = useSelector(selectMenus)

  const fixedBreadcrumbs = useSelector(selectFixedMenus)

  const breadcrumbs = useSelector(selectBreadcrumbs)

  const currentRoute = useSelector(selectCurrentRoute)

  const dispatch = useDispatch<RootDispatch>()

  const [collapsed, setCollapsed] = useState(false)

  const [overlayVisible, setOverlayVisible] = useState(false)

  const [isOverMenu, setIsOverMenu] = useState(false)

  const userId = useSelector(selectUserId)

  const isTipTetx = useSelector(selectAppShadeTipText)

  const shadeIsVisible = useSelector(selectAppShadeIsModal)

  useEffect(() => {
    console.log(shadeIsVisible, 'shadeIsVisible')
  }, [shadeIsVisible])

  useEffect(() => {
    if (!shadeIsVisible) {
      dispatch(setAppShadeTipText('请稍后~~~'))
    } else {
      setTimeout(() => {
        dispatch(setAppShadeIsModal(false))
        dispatch(setAppShadeTipText('请稍后~~~'))
      }, 20000)
    }
  }, [shadeIsVisible])

  useEffect(() => {
    dispatch(getMenus())
    if (applicationType === ApplicationType.Application) {
      dispatch(
        getPrintTemplateList({ templateCategory: PrintTemplateCategory.Zds })
      )
        .then(unwrapResult)
        .then((page) => {
          dispatch(
            setSettings({
              [Settings.Printing.HasTreatmentTemplate]: page.items.length > 0,
            })
          )
        })
      dispatch(getSettingDetail())
    } else {
      console.log(1)
    }
  }, [dispatch, applicationType])

  useEffect(() => {
    if (currentRoute) {
      let path = currentRoute.path
      if (currentRoute.query) {
        path = `${path}?${currentRoute.query}`
      }
      history.push(path, currentRoute.state)
    }
  }, [dispatch, history, currentRoute])

  useEffect(() => {
    if (
      currentRoute &&
      fixedBreadcrumbs.length > 0 &&
      currentRoute.path !== fixedBreadcrumbs[0].path
    ) {
      setCollapsed(true)
    } else if (!currentRoute && fixedBreadcrumbs.length > 0) {
      dispatch(traceHint(location.pathname))
    }
  }, [currentRoute, location.pathname, fixedBreadcrumbs])

  useEffect(() => {
    if (settings && Object.keys(settings).length !== 0) {
      const defaultMethod =
        (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
      dispatch(
        setSettings({
          [Settings.Treatment.DoNotWarnDoctorMismatch]:
            settings[Checks.Gbkdysstx] || false,
          [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
          [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
          [Settings.Payment.DefautMethod]: defaultMethod,
        })
      )
    }
  }, [settings])

  const overlay = (
    <Menu>
      <Menu.Item className={styles.upgrade}>
        <UpgradeOutlined />
        <div className={styles.version}>
          到期时间：{appEndTime?.format('YYYY-MM-DD')}
        </div>
      </Menu.Item>
      <Menu.Item
        className={styles.overlay}
        onClick={() =>
          dispatch(
            traceRoute({
              name: '个人中心',
              path: '/PersonalDetail',
              query: `state=${userId}`,
            })
          )
        }
      >
        <UserHomeOutlined />
        个人中心
        <Link to='/userCenter'></Link>
      </Menu.Item>
      <Menu.Item
        className={styles.overlay}
        onClick={() => {
          history.push('/')
          dispatch(removeCredentials())
          dispatch(removeBreadcrumbs())
          dispatch(resetDiagnosis())
        }}
      >
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  )

  const createMenu = (menu: MenuModel, hasIcon: boolean) => {
    const icon = collapsed ? (
      <div className={styles.stack}>
        <Icon icon={menu.icon} mode='normal' />
        <div>{menu.name}</div>
      </div>
    ) : (
      <Icon icon={menu.icon} />
    )
    return menu.subMenus.length !== 0 ? (
      <SubMenu
        key={menu.path}
        icon={hasIcon ? icon : undefined}
        title={menu.name}
        className={collapsed ? styles.menuCollapsed : styles.menu}
      >
        {menu.subMenus.map((sm) => createMenu(sm, false))}
      </SubMenu>
    ) : (
      <Menu.Item
        key={menu.path}
        icon={hasIcon ? icon : undefined}
        onClick={() => dispatch(traceRoute(menu))}
        className={
          hasIcon ? (collapsed ? styles.menuCollapsed : styles.menu) : undefined
        }
      >
        <Link to={menu.path}>{menu.name}</Link>
      </Menu.Item>
    )
  }

  return (
    <>
      <Layout
        style={{
          width: '100vw',
          height: '100vh',
        }}
      >
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          className={styles.sider}
          style={{
            overflow: 'hidden',
            height: '100vh',
            position: 'fixed',
            left: 0,
          }}
        >
          {collapsed ? (
            <LogoFilled className={styles.logo} />
          ) : (
            <div className={styles.name}>{shortName || tenantName} </div>
          )}
          <Menu
            defaultSelectedKeys={menus?.length ? [menus[0].path] : []}
            inlineIndent={32}
            onMouseEnter={() => setIsOverMenu(true)}
            onMouseLeave={() => setIsOverMenu(false)}
            onMouseMove={() => setIsOverMenu(true)}
            style={{
              overflow: isOverMenu ? (isChrome ? 'overlay' : 'auto') : 'hidden',
              flex: '1',
            }}
          >
            {menus.map((menu) => createMenu(menu, true))}
          </Menu>
        </Sider>
        <Layout
          style={{
            marginLeft: collapsed ? 80 : 200,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
          }}
        >
          <Header className={styles.header}>
            <DoubleLeftOutlined
              className={styles.scroll}
              onClick={() => {
                ref.current?.scrollBy({ left: -80, behavior: 'smooth' })
              }}
            />
            <div ref={ref} className={styles.breadcrumb}>
              {fixedBreadcrumbs.map((m) => (
                <div
                  key={m.path}
                  className={
                    m.name === currentRoute?.name ? styles.current : styles.item
                  }
                  onClick={() => {
                    if (m.path !== currentRoute?.path) {
                      dispatch(traceRoute(m))
                      history.push(m.path)
                    }
                  }}
                >
                  {m.name}
                </div>
              ))}
              {breadcrumbs.map((m) => (
                <div
                  key={m.name}
                  className={
                    m.name === currentRoute?.name ? styles.current : styles.item
                  }
                  onClick={() => {
                    if (m.name !== currentRoute?.name) {
                      dispatch(traceRoute(m))
                    }
                  }}
                >
                  {m.name}
                  <CloseCircleFilled
                    style={{ fontSize: '0.75rem' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      dispatch(untraceRoute(m))
                    }}
                  />
                </div>
              ))}
            </div>
            <DoubleRightOutlined
              className={styles.scroll}
              onClick={() => {
                ref.current?.scrollBy({ left: 80, behavior: 'smooth' })
              }}
            />
            <RefreshFilled
              style={{ marginLeft: 40, cursor: 'pointer', fill: theme.hic }}
              onClick={() => {
                history.go(0)
              }}
            />
            <Dropdown
              className={styles.user}
              overlay={overlay}
              visible={overlayVisible}
              onVisibleChange={(visible) => setOverlayVisible(visible)}
            >
              <a>
                {`${userName} `}
                {overlayVisible ? <CaretUpOutlined /> : <CaretDownOutlined />}
              </a>
            </Dropdown>
          </Header>
          <Content className={styles.content}>
            <Switch>
              <Route exact path={['/home', '/admin/tenant']}>
                {/* <Tenants /> */}
                <TenantNavBar />
              </Route>
              <Route path='/admin/tenant/serviceDelay'>
                <ServiceDelay />
              </Route>
              <Route path='/admin/tenant/setting/tenentSetting'>
                <TenentSetting />
              </Route>
              <Route exact path='/admin/menu'>
                <Menus />
              </Route>
              <Route exact path='/admin/tenant/:tenantId/menu'>
                <GrantPage />
              </Route>
              <Route exact path='/admin/tenant/:tenantId/department'>
                <Departments />
              </Route>
              <Route exact path='/admin/tenant/:tenantId/user/:userId/menu'>
                <GrantPage />
              </Route>
              <Route exact path='/admin/tenant/:tenantId/user'>
                <Users />
              </Route>
              <Route exact path='/admin/tenant/:tenantId/print'>
                <PrintAssignment />
              </Route>
              {/* 数据导入 */}
              <Route exact path='/admin/tenant/DataImportPage'>
                <DataImportPage />
              </Route>
              {/* 订单记录 */}
              <Route exact path='/admin/tenant/OrderRecord'>
                <OrderRecordPage />
              </Route>
              {/* 续订价格设置 */}
              <Route exact path='/admin/tenant/PriceSet'>
                <PriceSetPage />
              </Route>
              {/* 机构管理-标签管理 */}
              <Route exact path='/admin/tenant/LabelManagement'>
                <LabelManagementPage />
              </Route>
              <Route exact path='/personalSetting'>
                <UserPersonalSetting />
              </Route>
              {/* 医疗目录 */}
              <Route exact path='/admin/medical'>
                <Medical />
              </Route>
              {/* 医保目录 */}
              <Route exact path='/admin/insurance'>
                <Insurance />
              </Route>
              {/* 数据分析-HIS 数据 */}
              <Route exact path='/admin/monitoring/his'>
                <MonitoringTab />
              </Route>
              {/* 数据分析-监管数据 */}
              <Route exact path='/admin/monitoring/regulatory'>
                <RegulatoryDataTab />
              </Route>
              {/* 广告管理 */}
              <Route exact path='/admin/advertising'>
                <Advertising />
              </Route>
              {/* 代煎中心 代煎饮片厂 */}
              <Route
                exact
                path={[
                  '/admin/replaceMakeCenter',
                  '/admin/replaceMakeCenter/replaceMakeSupplier',
                ]}
              >
                <ReplaceCenter />
              </Route>
              {/* 代煎饮片厂合作机构 */}
              <Route exact path={'/admin/replaceMakeCenter/SupplierPartner'}>
                <SupplierPartner />
              </Route>
              {/* 代煎饮片厂药品目录 */}
              <Route exact path={'/admin/replaceMakeCenter/HerbsDirectory'}>
                <HerbsDirectoryPage />
              </Route>
              {/* 代煎机构合作饮片厂 */}
              <Route
                exact
                path={'/admin/replaceMakeCenter/OrganizationPartner'}
              >
                <OrganizationPartner />
              </Route>
              {/* 代煎机构 */}
              <Route
                exact
                path={'/admin/replaceMakeCenter/replaceMakeOrganization'}
              >
                <ReplaceMakeOrganization />
              </Route>
              {/* 统计分析 */}
              <Route exact path={'/admin/replaceMakeCenter/statisticAnalysis'}>
                <StatisticAnalysisNavBar />
              </Route>
              {/* 订单详情 */}
              <Route exact path={'/admin/replaceMakeCenter/orderDetail'}>
                <ReplaceMakeOrderDetail />
              </Route>
              {/* 合作平台 */}
              <Route exact path={'/admin/partner'}>
                <PartnerPlatform />
              </Route>
              {/* 消息中心 */}
              <Route exact path={'/admin/notification'}>
                <NotificationStatin />
              </Route>
              {/* 增值服务预约 */}
              <Route exact path={'/admin/reservationChannelList'}>
                <ReservationChannelList />
              </Route>
              {/* 版本管理 */}
              <Route exact path={'/admin/versionManagement'}>
                <VersionManagement />
              </Route>
              {/* AI页面 */}
              <Route exact path='/admin/aituning'>
                <AiTuningPage />
              </Route>
              <Redirect from='*' to='/admin/tenant'></Redirect>
              <Route path='*'>
                <NotFound />
              </Route>
            </Switch>
          </Content>
        </Layout>
      </Layout>
      {shadeIsVisible ? (
        <div className={styles.back}>
          <p className={styles.tip}>{isTipTetx}</p>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
